import * as React from 'react'
import { getMetricScript } from '../../utils/csm'

// Because we're using componentDidMount
// the Critical Feature (aka CF or cf) metric will correspond
// to the time after the react hydrate
class CFMarker extends React.Component {
  componentDidMount() {
    const script = document.createElement('script')
    script.innerHTML = getMetricScript('cf')
    document.body.appendChild(script)
  }

  render(): any {
    return null
  }
}

export default CFMarker
